














































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { PostFeedback } from "@/request/common";
@Component({})
export default class Name extends Vue {
  @Prop()
  private model: any;
  @Prop()
  private ifShow: any;
  @Watch("ifShow", { immediate: true })
  private ifShowChange() {
    this.visible = this.ifShow;
    this.$forceUpdate();
    if (this.ifShow) {
      this.data = {
        else_need: false,
      };
    }
  }
  private visible: any;
  private data: any = {
    else_need: false,
  };
  private changeStar(val: any) {
    this.data.evaluation = val;
    this.$forceUpdate();
  }
  private cancel() {
    this.$emit("cancel");
  }
  private save() {
    console.log(this.data);
    if (!this.data.evaluation) {
      this.$message.warning("请选择内容评价");
      return;
    }
    if (this.data.else_need && !this.data.need_content) {
      this.$message.warning("请输入具体需求");
      return;
    }
    this.data.module = this.model;
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostFeedback(this, this.data, loading).then(() => {
      this.$message.success("保存成功");
      this.cancel();
    });
  }
}
